/******************************************************************************************
 *	Product Entity
 ******************************************************************************************/
(function() {


  angular
    .module('rcEntities.product', [])
    .constant('PRODUCT_LICENSE_TYPES', {
      USER: 'STANDARD',
      DEVICE: 'MACHINE_ONLY'
    })
    .factory(
      'RcProduct',
      /* @ngInject */
      function(
        PRODUCT_LICENSE_TYPES,
        _,
        feature,
        FULFILLABLE_ITEM_CHARGING_MODEL_TYPE,
        FULFILLABLE_ITEM_DELEGATION_TYPE,
        RcProductList
      ) {
        function RcProduct(data, orgId, contractId) {
          this.activeSellableSku = data.activeSellableSku;
          this.offerId = data.offerId;
          this.name = data.productName;
          this.code = data.productCode;
          this.licenseType = data.licenseType;
          this.orgId = orgId;
          this.contractId = contractId;

          // We don't show language for SUPPORT products, so don't include it
          if (this.code !== 'SUPPORT') {
            this.language = data.language;
            // For migrated teams, we get 1 product entry for all languages, and then get
            // the quantities for each language split out separately.
            this.languageQuantities = data.languageQuantities;
            // if we only have one language in the array, set singular language value from the one language in the array.
            if (this.languageQuantities && this.languageQuantities.length === 1) {
              this.language = this.languageQuantities[0].language;
            }
            // Determine if we need to show a split between multiple language types for this product
            this.hasLicenseLanguageSplit = !!(
              this.languageQuantities && this.languageQuantities.length > 1
            );
          }
        }

        RcProduct.prototype.getBinkyProduct = function() {
          if (!this.binkyProduct) {
            var productList = RcProductList.get({contractId: this.contractId, orgId: this.orgId, includeLegacyLSFields: true});
            this.binkyProduct = _.find(productList.items, {
              offerId: this.offerId
            });
          }
          return this.binkyProduct;
        };

        RcProduct.prototype.getConsumableFICode = function() {
          var binkyProduct = this.getBinkyProduct();
          if (binkyProduct) {
            var quotaFulfillableItems = binkyProduct.fulfillableItemList.getQuotaTypeItems(false);
            return _.get(quotaFulfillableItems, '[0].code');
          }
          return '';
        };

        RcProduct.prototype.getConsumableUnits = function() {
          return _.get(this.getConsumableUnitsObject(), 'default');
        };

        RcProduct.prototype.getConsumableUnitsForQuantity = function(quantity) {
          const unitsObject = this.getConsumableUnitsObject();
          const defaultUnits = unitsObject.default;
          switch (quantity) {
            case 0:
              return _.get(unitsObject, '0', defaultUnits);
            case 1:
              return _.get(unitsObject, '1', defaultUnits);
            default:
              return defaultUnits;
          }
        };

        RcProduct.prototype.getConsumableUnitsObject = function() {
          var binkyProduct = this.getBinkyProduct();
          if (binkyProduct) {
            var quotaFulfillableItems = binkyProduct.fulfillableItemList.getQuotaTypeItems(false);
            // if no units object was provided, make one from the charging model's units
            return _.get(quotaFulfillableItems, '[0].units', {
              default: _.get(quotaFulfillableItems, '[0].chargingModel.unit')
            });
          }
          return {default: ''};
        };

        RcProduct.prototype.getConsumableCap = function() {
          var binkyProduct = this.getBinkyProduct();
          if (binkyProduct) {
            var quotaFulfillableItems = binkyProduct.fulfillableItemList.getQuotaTypeItems(false);
            return _.get(quotaFulfillableItems, '[0].chargingModel.cap');
          }
          return 0;
        };

        RcProduct.prototype.getConsumableTotalQuantity = function() {
          const cap = _.parseInt(this.getConsumableCap());
          const binkyProduct = this.getBinkyProduct();
          const quantity = _.invoke(
            binkyProduct,
            'licenseQuantityList.getPaidOrPendingOrGracePastDueQuantity'
          );
          if (_.isInteger(cap) && _.isInteger(quantity)) {
            return cap * quantity;
          }
          return 0;
        };

        RcProduct.prototype.getConsumableName = function() {
          var binkyProduct = this.getBinkyProduct();
          if (binkyProduct) {
            var quotaFulfillableItems = binkyProduct.fulfillableItemList.getQuotaTypeItems(false);
            return _.get(quotaFulfillableItems, '[0].longName', this.name);
          }
          return this.name;
        };

        RcProduct.prototype.getLicenseId = function() {
          var binkyProduct = this.getBinkyProduct();
          if (binkyProduct) {
            return binkyProduct.id;
          }
          return '';
        };

        //Determine license type
        RcProduct.prototype.hasUserLicense = function() {
          return this.licenseType && this.licenseType === PRODUCT_LICENSE_TYPES.USER;
        };
        RcProduct.prototype.hasDeviceLicense = function() {
          return this.licenseType && this.licenseType === PRODUCT_LICENSE_TYPES.DEVICE;
        };
        RcProduct.prototype.isConsumptionBasedLicense = function() {
          var binkyProduct = this.getBinkyProduct();
          if (binkyProduct && binkyProduct.isConsumable()) {
            const quotaFulfillableItems = binkyProduct.fulfillableItemList.getQuotaTypeItems(false);
            // RC doesn't want to sort NUELL products under Consumption-based licenses, so exclude them here
            return !_.some(quotaFulfillableItems, {
              delegationType: FULFILLABLE_ITEM_DELEGATION_TYPE.MACHINE
            });
          }
          return false;
        };

        RcProduct.prototype.isSharedDeviceLicense = function() {
          var binkyProduct = this.getBinkyProduct();
          if (binkyProduct) {
            return binkyProduct.fulfillableItemList.hasLaboratoryLicenseManagement();
          }
          return false;
        };

        RcProduct.prototype.isConsolidated = _.constant(false);

        RcProduct.prototype.isOnDemandConsumable = function() {
          var binkyProduct = this.getBinkyProduct();
          if (binkyProduct && binkyProduct.isConsumable()) {
            const quotaFulfillableItems = binkyProduct.fulfillableItemList.getQuotaTypeItems(false);
            const chargingModelType = _.get(quotaFulfillableItems, '[0].chargingModel.model');
            return chargingModelType === FULFILLABLE_ITEM_CHARGING_MODEL_TYPE.ON_DEMAND;
          }
          return false;
        };

        RcProduct.prototype.setConsumableData = function(consumables) {
          this.consumables = consumables;
        };

        return RcProduct;
      }
    );
})();
